import { useTranslation } from 'react-i18next';
import type { Platform } from '../data/projects';

export function usePlatformLabel(): (platforms: Platform[]) => string {
    const { t } = useTranslation();

    return (platforms: Platform[]) => platforms.map((platform) => t(`platforms.${platform}`)).join(', ');
}
